document.addEventListener('DOMContentLoaded', () => {
  const reelsVideos = document.querySelectorAll('.reel-item video');

  // Simple intersection observer to pause videos when they go out of view
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target.paused) {
            entry.target.play().catch(e => console.warn('Autoplay prevented:', e));
          }
        } else {
          if (!entry.target.paused) {
            entry.target.pause();
          }
        }
      });
    }, { threshold: 0.5 });

    reelsVideos.forEach(video => {
      observer.observe(video);
    });
  }
});
